import { createReminderSettingsSnapshot } from "./reminder-settings";

function relevantKindKeys(scope) {
  if (scope === "basic" || scope === "embedded") return ["basicPollVotes"];
  return ["sessionVotes", "basicPollVotes", "upcomingSessions"];
}

export function pollReminderSummary(value, inheritedValue, scope = "session") {
  const settings = createReminderSettingsSnapshot(value);
  const inherited = createReminderSettingsSnapshot(inheritedValue);
  const customized = JSON.stringify(settings) !== JSON.stringify(inherited);
  if (!settings.enabled) return customized ? "Notifications: Off" : "Notifications: Group defaults (off)";
  const alertCount = relevantKindKeys(scope).reduce(
    (count, key) => count + (settings[key].enabled ? settings[key].offsetsMinutes.length : 0),
    0
  );
  return customized
    ? `Notifications: Custom · ${alertCount} ${alertCount === 1 ? "alert" : "alerts"}`
    : `Notifications: Group defaults · ${alertCount} ${alertCount === 1 ? "alert" : "alerts"}`;
}
